import { useContext, useEffect, useState } from 'react';
import { UsersContextDetail } from '../../../userContextDetail';
import PageLoader from 'common/PageLoader';

type CancelPopProps = {
  isOpen: boolean;
  onClose: () => void;
  booking: {
    id: string;
    status?: string;
    date?: string;
    meals?: string[];
    additionalServices?: string[];
  };
};

const CancelPop: React.FC<CancelPopProps> = ({ isOpen, onClose, booking }) => {
  const {
    updateBooking,
    updateBookingState: { isLoading, status, error },
  } = useContext(UsersContextDetail)!;

  const [clickedConfirm, setClickedConfirm] = useState(false);

  const handleClick = async () => {
    setClickedConfirm(true);
    const statusValue = '1';
    await updateBooking(
      booking.id,
      booking.date || '',
      booking.meals?.join(',') || '', // convert array to string, fallback to empty string
      booking.additionalServices?.join(',') || '', // if this is also an array
      statusValue
    );
  };

  useEffect(() => {
    if (clickedConfirm && status === 200 && !isLoading && !error) {
      onClose();
      setClickedConfirm(false);
    }
  }, [clickedConfirm, status, isLoading, error, onClose]);

  if (isLoading) return <PageLoader />;

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: '24px 32px',
          borderRadius: 10,
          width: '100%',
          maxWidth: 500,
          boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
        }}
      >
        <h4 style={{ marginBottom: 40, textAlign: 'center' }}>
          Once cancelled, this booking cannot be recovered. Are you sure you
          want to continue?
        </h4>
        {isLoading && <p style={{ color: '#007bff' }}>Cancelling...</p>}
        {clickedConfirm && status === 200 && !error && !isLoading && (
          <p style={{ color: 'green' }}>Booking cancelled successfully.</p>
        )}
        {clickedConfirm && error && !isLoading && (
          <p style={{ color: 'red' }}>Failed to cancel booking. Try again.</p>
        )}

        <div
          style={{
            display: 'flex',
            gap: 10,
            justifyContent: 'center',
            marginTop: 20,
          }}
        >
          <button
            style={{
              padding: '8px 20px',
              backgroundColor: '#fff',
              color: '#545454',
              border: 'solid 1px',
              borderRadius: 10,
              cursor: 'pointer',
            }}
            onClick={() => {
              onClose();
              setClickedConfirm(false); // Reset on close
            }}
            disabled={isLoading}
          >
            Close
          </button>
          <button
            style={{
              padding: '8px 20px',
              backgroundColor: '#fff',
              color: '#d02429',
              border: '#d02429 solid 1px',
              borderRadius: 10,
              cursor: 'pointer',
            }}
            onClick={handleClick}
            disabled={isLoading}
          >
            {isLoading ? 'Cancelling...' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelPop;
